var React = require('react');

function ListViewInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"strokeLinejoin":"round","d":"M6 3h8","key":0}),React.createElement("path",{"d":"M2 3h1M2 8h1M2 13h1M6 8h8M6 13h8","key":1})]));
}

ListViewInline.defaultProps = {"width":"16","height":"16"};

module.exports = ListViewInline;

ListViewInline.default = ListViewInline;
